/* */ 
'use strict';
var debug = require('debug'),
    util = require('util');
exports.format = util.format;
exports.inherits = util.inherits;
exports.debug = debug('swagger:parser');
exports.swaggerParamRegExp = /\{([^/}]+)}/g;
